<template>
  <div>
exhibition-release-new-pass
  </div>
</template>

<script>
export default {
  name:  'exhibition-release-new-pass',
  data() {
    return {

    }
  },
  components: {

  },
  computed: {

  },
  methods: {

  },
}
</script>

<style scoped lang="scss">

</style>

